// extracted by mini-css-extract-plugin
export default {"flex-box":"index_flex-box__cVmg0","place-holder":"index_place-holder__KQP90","shareViewWrapper":"index_shareViewWrapper__zqUGl","boardWrapper":"index_boardWrapper__k6phV"};